import { ImportModule } from "app/helpers/importsHelper";
import { ROUTES } from "app/helpers/routerPathHelper";

const MobileRouteHelper = [
  {
    path: ROUTES.events,
    component: ImportModule.CompetitionsScreenWrapper,
    exact: true,
  },
  {
    path: ROUTES.eventsBySport, // '/events/sports/sportName or id'
    component: ImportModule.CompetitionsScreenWrapper,
  },
  {
    path: ROUTES.eventsByCompetition, // '/events/competitions/competitionName or id'
    component: ImportModule.CompetitionsScreenWrapper,
  },
  {
    path: ROUTES.bookmarks,
    component: ImportModule.CompetitionsScreenWrapper,
  },
  {
    path: ROUTES.futures,
    component: ImportModule.CompetitionsScreenWrapper,
  },
  {
    path: ROUTES.favourites,
    component: ImportModule.CompetitionsScreenWrapper,
  },
  {
    path: ROUTES.eventDetail,
    component: ImportModule.CompetitionsScreenWrapper,
    exact: true,
  },
  {
    path: ROUTES.promoCategory,
    component: ImportModule.CompetitionsScreenMobile,
    exact: true,
  },
  {
    path: ROUTES.bets,
    component: ImportModule.BetDrawerScreen,
    exact: true,
  },
  {
    path: ROUTES.singleEventDetail,
    component: ImportModule.EventDetailScreen,
    exact: true,
  },
  {
    path: ROUTES.reports,
    component: ImportModule.ReportsScreen,
    exact: true,
  },
  {
    path: ROUTES.manageFunding,
    component: ImportModule.ManageFundingScreen,
    exact: false,
  },
  {
    path: ROUTES.helpAndLearning,
    component: ImportModule.HelpAndLearningScreen,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningWelcomeHelpAndLearning,
    component: ImportModule.HelpAndLearningWelcomeHelpAndLearning,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedFundingYourAccount,
    component: ImportModule.HelpAndLearningGettingStartedFundingYourAccount,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedPlacingABet,
    component: ImportModule.HelpAndLearningGettingStartedPlacingABet,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedOurOdds,
    component: ImportModule.HelpAndLearningGettingStartedOurOdds,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedQuickLinks,
    component: ImportModule.HelpAndLearningGettingStartedQuickLinks,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningRulesAndRegulationsSportsRules,
    component: ImportModule.HelpAndLearningRulesAndRegulationsSportsRules,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningRulesAndRegulationsMarketRules,
    component: ImportModule.HelpAndLearningRulesAndRegulationsMarketRules,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningRulesAndRegulationsCodeOfConduct,
    component: ImportModule.HelpAndLearningRulesAndRegulationsCodeOfConduct,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningContactAndSupportContactUs,
    component: ImportModule.HelpAndLearningContactAndSupportContactUs,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningFaqsMyAccount,
    component: ImportModule.HelpAndLearningFaqsMyAccount,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningFaqsFunding,
    component: ImportModule.HelpAndLearningFaqsFunding,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningFaqsBetting,
    component: ImportModule.HelpAndLearningFaqsBetting,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningAboutUsLicenceInformation,
    component: ImportModule.HelpAndLearningAboutUsLicenceInformation,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningResponsibleGaming,
    component: ImportModule.HelpAndLearningResponsibleGaming,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningSelfExclusion,
    component: ImportModule.HelpAndLearningSelfExclusion,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningTermsAndConditions,
    component: ImportModule.HelpAndLearningTermsAndConditions,
    exact: true,
  },
  {
    path: ROUTES.helpAndLearningTermsAndConditionsPrivacyPolicy,
    component: ImportModule.HelpAndLearningTermsAndConditionsPrivacyPolicy,
    exact: true,
  },
  {
    path: ROUTES.profile,
    component: ImportModule.ProfileScreen,
    exact: true,
  },
  {
    path: ROUTES.account,
    component: ImportModule.AccountScreen,
    exact: true,
  },
  {
    path: ROUTES.accountVerification,
    component: ImportModule.AccountVerificationScreen,
    exact: true,
  },
  {
    path: ROUTES.accountcontrols,
    component: ImportModule.AccountControlsScreen,
    exact: true,
  },
];
export default MobileRouteHelper;
